/* eslint-disable sonarjs/no-duplicate-string */

'use strict';

const clientSideValidation = require('../components/clientSideValidation');
const bisnAttrHelper = require('./components/bisnAttrHelper');
const inventoryState = {
    fetching: false,
    data: null
};

/**
 * Get inventory data.
 * @returns {Promise} - Resolved with data or rejected with error.
 */
function getInventory() {
    return new window.Promise((resolve, reject) => {
        const urlElement = document.querySelector('[data-inventory-url]');
        const url = urlElement ? urlElement.getAttribute('data-inventory-url') || null : null;

        if (!url) {
            reject(new Error('Missing data inventory url'));
            return;
        }

        // Use previously fetched data.
        if (inventoryState.data) {
            resolve(inventoryState.data);
            return;
        }

        inventoryState.fetching = true;

        setTimeout(function () {
            $.ajax({
                url: url,
                type: 'POST',
                dataType: 'json',
                success(data) {
                    inventoryState.fetching = false;

                    if (data.productInventory && typeof data.productInventory === 'object') {
                        inventoryState.data = data.productInventory;
                        resolve(data.productInventory);
                    } else {
                        reject(
                            new Error('Missing property on inventory response')
                        );
                    }
                },
                error(error) {
                    inventoryState.fetching = false;

                    reject(
                        new Error(`Error on fetching inventory data (${error.statusText || 'unspecified status'})`)
                    );
                }
            });
        }, 2);
    });
}

/**
 * Validates the BISN Email field on blur out event.
 * @returns {void}
 */
function validateBISNBlur() {
    var textInputFields = '.bisn-email';

    $('body').on('blur', textInputFields, function (event) {
        clientSideValidation.functions.handleOnBlur.apply(this, [event]);
    });
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body of the modal window
 *
 * @return {Object} - Object with properties body.
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.bisn-body');

    return { body: body };
}

/**
 * replaces the content in the modal window for bisn product variation selection.
 * @param {string} bisnProductUrl - url to be used to retrieve a new BISN product model
 */
function fillBISNModalElement(bisnProductUrl) {
    $('#bisnProductModal').spinner().start();
    $.ajax({
        url: bisnProductUrl,
        method: 'POST',
        dataType: 'json',
        success: function (data) {
            $('#bisnProductModal')[0].openSheet($('.bisn-button')[0]);
            var parsedHtml = parseHtml(data.renderedTemplate);
            $('#product-recommender-bisn').addClass('d-none');
            $('#bisnProductModal .bisn-body').remove();
            $('#bisnEmail').val('');
            $('.bisn-success-button').prop('disabled', true);
            $('#bisnProductModal .bisn-body-wrapper').html(parsedHtml.body);

            $('.bisn-success-hide').removeClass('d-none');
            $('.bisn-success-show').addClass('d-none');
            // Ensure the textInput web component is not disabled by using its custom method
            document.querySelector('text-input-component.email-content')?.setDisabled(false);

            // Deselect all buttons
            $('.bisn-modal button').removeClass('selected');
            // Select and click correct colorway button
            var colorValue = $('.color-style button.selected').data('attrvalue');
            $('.bisn-modal button span[data-bisn-attr-value=' + colorValue + ']').closest('button').addClass('selected').trigger('click');
            $('#bisnProductModal').find('form').find('.form-control.is-invalid, .form-check-input.is-invalid, .custom-control-input.is-invalid').removeClass('is-invalid');
            setTimeout(function () {
                if ($('#product-recommender-bisn').find('.horizontal-product-carousel').length > 0) {
                    $('#product-recommender-bisn').removeClass('d-none');
                    $('body').trigger('bisn-carousel:setup', {});
                }
            }, 800);
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * updates the product view when a product attribute is selected or deselected or when
 *         changing quantity
 * @param {string} selectedValueUrl - the Url for the selected variation value
 * @param {jQuery} $productContainer - DOM element for current product
 * @param {string} baseAttribute - check for baseAttribute
 */
function attributeSelect(selectedValueUrl, $productContainer, baseAttribute) {
    if (selectedValueUrl) {
        $('body').trigger('product:beforeBisnAttributeSelect',
            { url: selectedValueUrl, container: $productContainer });
        $productContainer.find('.attributes').spinner().start();
        $.ajax({
            url: selectedValueUrl,
            method: 'GET',
            success: function (data) {
                if (data.product.variationAttributes) {
                    bisnAttrHelper.updateBisnAttrs(data.product.variationAttributes, $productContainer, data.resources, 'bisn', baseAttribute);
                }
                $('.bisn-form input[name=pid]').val(data.product.productType !== 'master' ? data.product.id : '');
                $('body').trigger('product:afterBisnAttributeSelect', { data: data, container: $productContainer });
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    }
}

/**
 * Handle Filter Recommendations.
 * @param {JQuery} element - the jquery element that has the click event attached
 */
function filterRecommendationsOnBISN(element) {
    if (window.sitePrefs.enableFilterRecommendations && window.sitePrefs.enableFilterRecommendationsBISN) {
        var $currentElement = $(element);
        if ($currentElement.data('bisn-attr') === 'size-value') {
            var $filterRecommendation = $('.filter-recommendations');
            if ($filterRecommendation && $filterRecommendation.length > 0) {
                var isFootwear = $filterRecommendation.data('footwear');
                var gender = $filterRecommendation.data('gender');
                var size = $currentElement.data('attrvalue');
                if (isFootwear && size && gender) {
                    var params = 'size=' + size + '&gender=' + gender;
                    $(document).trigger('filterEinsteinRecommendations', params);
                }
            }
        }
    }
}

module.exports = {
    bisnModal: function () {
        $(document).on('click', '#bisn-modal-trigger', function (e) {
            e.preventDefault();
            var bisnUrl = new URL(this.dataset.url);
            var bisnPid = bisnUrl.searchParams.get('pid');

            if (inventoryState.fetching) {
                return; // Ignore fast clicks.
            }

            getInventory()
                .then((productInventory) => {
                    if (productInventory[bisnPid]) {
                        var firstOOSVariant = Object.keys(productInventory[bisnPid].variants).find(function (variant) {
                            return productInventory[bisnPid].variants[variant].status === 'NOT_AVAILABLE';
                        });
                        if (firstOOSVariant) {
                            bisnUrl.searchParams.append('firstOOSVariant', firstOOSVariant);
                        }
                    }
                    fillBISNModalElement(bisnUrl.toString());
                    $('.bisn-modal button').each(function () {
                        $('.bisn-modal button').removeClass('selected');
                        var colorValue = $('.color-style button.selected').data('attrvalue');
                        $('.bisn-modal button span[data-bisn-attr-value=' + colorValue + ']').closest('button').addClass('selected');
                    });
                })
                .catch((error) => {
                    if (window.console) {
                        window.console.warn(error);
                    }
                });
        });

        $(document).on('sheet:close', '#bisnProductModal', function () {
            $('.bisn-body').remove();
        });
    },
    swatchAttribute: function () {
        $(document).on('click', '[data-bisn-attr="size-value"], [data-bisn-attr="style-value"], [data-bisn-attr="width-value"], [data-bisn-attr="cup-value"]', function (e) {
            e.preventDefault();
            var $this = $(this);
            var selectedVariant = $this.attr('data-bisn-attr');
            var returnEarly = false;
            $('#bisnProductModal .attribute').each(function () {
                var sizeAttr = $(this).find('.size-attribute');
                if (sizeAttr.length && sizeAttr.find('.selected').length < 1) {
                    if (selectedVariant === 'width-value') {
                        $(this).addClass('error');
                        returnEarly = true;
                    }
                } else if (sizeAttr.length) {
                    $(this).removeClass('error');
                }
            });
            if ($this.attr('disabled') || returnEarly) {
                return;
            }
            var $productContainer = $this.closest('.product-detail');
            var baseAttribute = $this.attr('data-base-url');
            attributeSelect(baseAttribute || $this.attr('data-url'), $productContainer, selectedVariant);
        });
    },
    sizeSelect: function () {
        $(document).on('click', '[data-bisn-attr="size-value"]', function () {
            filterRecommendationsOnBISN(this);
        });
    },
    submitNotify: function () {
        $('.bisn-form').on('submit', function (e) {
            e.preventDefault();
            var returnEarly = false;
            $('#bisnProductModal .attribute').each(function () {
                var $this = $(this);
                var lenVal = $this.find('.selected').length;
                if (lenVal < 1) {
                    $this.addClass('error');
                    returnEarly = true;
                } else {
                    $this.removeClass('error');
                }
            });
            if (returnEarly) {
                return;
            }
            $('#bisnProductModal .detail-panel').spinner().start();
            var $form = $('.bisn-form');
            $.ajax({
                url: $form.attr('action'),
                method: 'POST',
                data: $form.serialize(),
                success: function (data) {
                    if (data.success) {
                        $('.bisn-success-hide').addClass('d-none');
                        $('.bisn-success-show').removeClass('d-none');
                        // Disable the textInput web component using its custom setDisabled method
                        document.querySelector('text-input-component.email-content')?.setDisabled(true);
                    }
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },
    validateBISNBlur: validateBISNBlur
};
